export default "__VITE_ASSET__DBvIjoZA__"